import React from 'react';
import { Helmet } from 'react-helmet-async';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Calculator } from './components/Calculator';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Features } from './components/Features';
import { About } from './components/About';
import { Privacy } from './pages/Privacy';
import { Terms } from './pages/Terms';
import { Cookies } from './pages/Cookies';
import { Disclaimer } from './pages/Disclaimer';
import './App.css';

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col bg-stone-50">
        <Helmet>
          <title>Asphalt Calculator - Professional Construction Estimator</title>
          <meta name="description" content="Estimate asphalt pavement tonnage required for your construction project with our professional asphalt calculator. Get accurate measurements for your job site." />
          <meta name="keywords" content="asphalt calculator, pavement calculator, construction calculator, asphalt estimator, asphalt tonnage" />
          <meta property="og:title" content="Asphalt Calculator - Professional Construction Estimator" />
          <meta property="og:description" content="Estimate asphalt pavement tonnage required for your construction project with our professional asphalt calculator." />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://asphaltcalculator.online" />
          <link rel="canonical" href="https://asphaltcalculator.online" />
          <script type="application/ld+json">
            {`
              {
                "@context": "https://schema.org",
                "@type": "WebApplication",
                "name": "Asphalt Calculator",
                "url": "https://asphaltcalculator.online",
                "description": "Professional tool for estimating asphalt pavement tonnage required for construction projects.",
                "applicationCategory": "ConstructionApplication",
                "operatingSystem": "Web",
                "offers": {
                  "@type": "Offer",
                  "price": "0",
                  "priceCurrency": "USD"
                }
              }
            `}
          </script>
        </Helmet>
        <Header />
        <Routes>
          <Route path="/" element={
            <main className="flex-grow flex flex-col items-center justify-start px-4 py-8">
              <section id="calculator" className="w-full max-w-4xl mb-16">
                <Calculator />
              </section>
              <section id="features" className="w-full max-w-4xl mb-16">
                <Features />
              </section>
              <section id="about" className="w-full max-w-4xl">
                <About />
              </section>
            </main>
          } />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;